// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wOP2","question":"styles_question__2Xu8a","inputVisibleButton":"styles_inputVisibleButton__3H0Aa","note":"styles_note__23cQC"};